// extracted by mini-css-extract-plugin
export default {"container":"CommentInput_container__tW-ng","inputBar":"CommentInput_inputBar__3OJdF","inputZone":"CommentInput_inputZone__V4P3E","enter":"CommentInput_enter__o1jYb"};